import { OnboardingDialog } from './onboarding-dialog';
import { useUserContext } from '../../../Contexts/User';
import { V2_ONBOARDING_CUTOFF_DATE } from '../../constants/onboarding';

/**
 * Onboarding dialog for the Matter creation page explaining the new workflow.
 */
export function MatterCreationV2Onboarding() {
  const { user } = useUserContext();

  // Only show V2 onboarding to existing users (created before cutoff date)
  const userCreatedAt = user?.createdAt ? new Date(user.createdAt) : null;
  const isExistingUser = userCreatedAt && userCreatedAt < V2_ONBOARDING_CUTOFF_DATE;

  if (!isExistingUser) {
    return null;
  }

  return (
    <OnboardingDialog dialogId="matter-creation" icon="lucide--folder-plus" title="Creating a Matter">
      <h3 className="text-lg font-medium">Welcome to the Matter creation page</h3>
      <p>This is similar to the previous Matter creation page, but with some new fields.</p>
      <p>
        You now add <strong>legal issues</strong> and <strong>upload documents</strong> at the Matter level.
      </p>

      <p className="text-xs text-gray-500">
        If you leave this page this Matter will be saved as a Draft Matter. Also, you can finish creating this Matter
        and then come back to edit details or add more users and documents later.
      </p>
    </OnboardingDialog>
  );
}
